// extracted by mini-css-extract-plugin
export var fadeInOut = "_4s-3";
export var icon = "_4s-4";
export var savedIndicator = "_4s-2";
export var savingIndicator = "_4s-0";
export var spin = "_4s-1";